"use client";
import { DreamLogo } from "@portal/app/_components/ui-elements/DreamLogo";
import { getUrls } from "@portal/app/_common/lib/urls";
import CN from "classnames";
import { NavContainer } from "@portal/app/_components/ui-elements/CustomerNavBar/CustomerNavBar";

export const ErrorPageNavBar = () => (
  <NavContainer className={CN("dream_search_nav_bar", {})} $shouldHideSearch>
    <a href={getUrls().Home()}>
      <DreamLogo />
    </a>
  </NavContainer>
);
